export const getFCUrl = (url: string): string => {
    return url.includes("freeconvert.com") && new URL(url).hostname.includes("server")
        ? url.replace("server", "s")
        : url;
};
